import styled, { keyframes, css } from 'styled-components';
import EnumChartType from '../../../utils/enums/EnumChartType';

interface ChartProps {
  $APillarName: 'apillar1' | 'apillar2';
  $imageBackGround?: string;
  $chartType?: string;
  size?: string | number;
}

const fontFamily = `'Open Sans', sans-serif`;

export const Wrap = styled.div`
  width: 30cm; /* Largura da página A4 */
  min-height: 29.7cm; /* Altura mínima da página A4 (pode crescer) */

  display: flex;
  flex-direction: column;

  margin-top: 50px;
  padding: 20px;
  font-family: ${fontFamily};

  h1 {
    font-weight: 700;
    font-size: 70px;
    font-family: ${fontFamily};
    text-align: left;
  }
  h2 {
    font-weight: 800;
    font-size: 45px;
    font-family: ${fontFamily};
    text-align: left;
  }

  // h3 {
  //   font-weight: 400;
  //   font-family: ${fontFamily};
  // }
`;

export const Container = styled.div`
  display: flex;
  width: 100%;
  min-height: 640px;
  margin-top: 30px;
  align-items: center;
  flex-direction: column;

  @media (max-width: 1126px) {
    flex-direction: column;
  }
`;

export const LegendContainer = styled.div`
  display: flex;
  width: 550px;
  gap: 50px;
  justify-content: center;
  height: 60px;
  margin-top: 30px;
  // border: 1px solid black;
  border-radius: 20px;
  background-color: #f2efeb;
`;

const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const appearFromRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const ChartContainer = styled.div<ChartProps>`
  width: 695px;
  padding: 0 44px;
  /* display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; */

  background: ${({ $chartType, $imageBackGround }) =>
    $chartType === EnumChartType.Radar_v2
      ? `url(${$imageBackGround}) no-repeat 23px -6px`
      : `url(${$imageBackGround}) no-repeat 66px 24px`};

  ${({ $chartType }) =>
    $chartType &&
    `
      background-size: 642px;
    `}

  animation: ${appearFromLeft} 1s;

  @media (max-width: 1126px) {
    width: 100%;
    padding: 0;
    background-size: contain;
    background-position: center 40px;
    padding-bottom: 50px;
  }
`;

export const LeftContainer = styled.div`
  position: relative;
`;

export const TextContainer = styled.div`
  margin: 55px auto;
  background-color: #f2efeb;
  max-width: 850px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 50px;
  // margin-left: 30px;
  // margin-top: 55px;
  color: #682d45;
  font-family: ${fontFamily};
  // justify-self: center;
`;

export const Header = styled.div`
  padding: 20px 20px 20px 0;
  font-family: ${fontFamily};

  p {
    color: #f2efeb;
    text-align: left;
    margin-top: 10px;
    font-size: 32px;
    font-weight: 500;
    line-height: 1.5 !important;
    text-align: justify;
    font-family: ${fontFamily};
  }
  span {
    font-size: 32px;
    font-weight: 600;
    line-height: 1.2 !important;
    font-family: ${fontFamily};
  }
`;

// export const HeaderLine = styled.div`
//   display: flex;
//   margin-bottom: 14px;

//   h1 {
//     font-size: 28px;
//     flex: 1;
//     margin-right: 20px;
//   }
// `;

export const SubTitle = styled.div`
  display: flex;
  margin-bottom: 20px;
  margin-top: 20px;
  font-family: ${fontFamily};

  h1 {
    font-weight: 900;
    font-size: 36px;
    flex: 1;
    margin-right: 20px;
    color: #682d45;
    font-family: ${fontFamily};
  }
  span {
    color: #682d45;
    font-size: 36px;
    font-family: ${fontFamily};
  }
`;

export const Score = styled.span`
  font-size: 28px;
  color: #28000a;
  font-weight: bold;
  font-family: ${fontFamily};
`;

export const Body = styled.div`
  width: 100%;
  padding: 20px 30px;
  margin: 10px;
  font-size: 20px;
  font-family: ${fontFamily};
`;

export const Footer = styled.p`
  margin: 10px 0 0;
  font-size: 18px !important;
  color: #7f7f7f;
  font-family: ${fontFamily};
`;

export const BodyLine = styled.div<ChartProps>`
  display: flex;
  font-family: ${fontFamily};

  height: 55px;

  h3 {
    margin-bottom: 30px;
    font-size: 32px;
    font-weight: 500;
    line-height: 1.2 !important;
    font-family: ${fontFamily};
  }

  h4 {
    flex: 1;
    margin-right: 20px;
    margin-bottom: 30px;
    font-family: ${fontFamily};
  }

  ${props =>
    props.$APillarName === 'apillar2' &&
    css`
      &:last-child {
      }
    `}
`;

export const RefreshButton = styled.button`
  border: 0 none;
  background-color: transparent;
  display: inline-flex;
  margin: 0 190px 0 0;
  float: right;

  &:hover {
    opacity: 0.7;
  }
`;

export const ButtonLeft = styled.button`
  border: 0 none;
  background-color: transparent;
  position: absolute;
  top: 170px;
  left: -55px;

  &:hover {
    opacity: 0.7;
  }
`;

export const ButtonRight = styled.button`
  border: 0 none;
  background-color: transparent;
  position: absolute;
  top: 170px;
  right: -55px;

  &:hover {
    opacity: 0.7;
  }
`;

export const BottomContainer = styled.div`
  margin: 0 0 30px;

  p {
    margin: 10px 0 0;
    font-size: 13px;
  }
`;

export const BoxFooter = styled.div`
  background-color: #fff;
  padding: 14px;
  margin: 20px 0 0;

  ul {
    margin: 5px 30px;

    li {
      a {
        color: #017698;
        text-decoration: underline;
        margin-left: 5px;

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
`;

export const HeaderLine = styled.div`
  display: flex;
  margin-bottom: 35px;
  margin-top: 35px;
  font-family: ${fontFamily};

  h1 {
    font-weight: 900;
    font-size: 44px;
    flex: 1;
    margin-right: 20px;
    color: #682d45;
    font-family: ${fontFamily};
  }
  span {
    color: #682d45;
    font-size: 44px;
    font-family: ${fontFamily};
  }
`;

export const ChartWrapper = styled.div`
  position: relative;
  z-index: 2;
`;

export const SvgWrapper = styled.svg`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 36rem;
  height: 36rem;
  z-index: 1;

  /* Responsividade */
  @media (max-width: 480px) {
    width: 120px;
    height: 120px;
  }

  @media (min-width: 481px) and (max-width: 1024px) {
    width: 200px;
    height: 200px;
  }

  @media (min-width: 1025px) {
    width: 36rem;
    height: 36rem;
    max-width: 100%;
  }
`;
